<template>
    <div class="row">
        <div class="col-sm">
            <b-card no-body>
                <b-tabs card>
                    <b-tab
                        v-for="group in filtered_items"
                        :key="group.name"
                        :title="group.name"
                    >
                        <div class="row">
                            <div
                                v-for="section in group.children"
                                :key="section.name"
                                class="dashboard-menu pb-4 col-sm-12 col-lg-6"
                            >
                                <div class="list-group">
                                    <label class="list-group-item active">{{
                                        section.name
                                    }}</label>

                                    <router-link
                                        v-for="child in section.children"
                                        :key="child.title"
                                        :to="child.to"
                                        class="list-group-item list-group-item-action d-flex"
                                    >
                                        <div class="align-self-start">
                                            <component
                                                :is="child.icon + '-icon'"
                                            ></component>
                                        </div>

                                        <div class="align-self-start flex-fill">
                                            &nbsp; {{ child.title }}
                                        </div>

                                        <div class="align-self-end">
                                            <menu-right-outline-icon />
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>
<script>
import MenuRightOutlineIcon from "vue-material-design-icons/MenuRightOutline";
import MenuMixin from "./MenuMixin";

export default {
    name: "OSectionDashboardMenu",
    mixins: [MenuMixin],
    components: { MenuRightOutlineIcon },
    props: {
        items: {},
    },
    computed: {},
    created() {
        console.log("Consider upgrading to ONavDashboardMenu");
    },
};
</script>
a
